import { useTranslation } from "react-i18next"
import PageLayout from "components/layout/PageLayout"
import { useGetCompanyLogQuery, useGetCurrentUserLogQuery } from "./api/logApiSlice"
import LogTable from "./components/LogTable"
import { useState } from "react"

const UserLog = () => {

    const [t, i18n] = useTranslation(["global"])
    const [pageNumber, setPageNumber] = useState(0);
    const [pageSize, setPageSize] = useState(25); // Page size dinamico

    const {
        data: companyLog,
        isFetching,
        isSuccess,
        isError,
        error,
        refetch
    } = useGetCurrentUserLogQuery({
        pageNumber,
        pageSize,
    });


    return <PageLayout
        pageTitle={t("menu.activity_log")}
        onPageRefresh={refetch}
        isLoadingContent={isFetching}
        bodyContent={
            companyLog ? (
                <LogTable
                    showAgent={false}
                    thirdPerson={false}
                    logData={companyLog.content}
                    totalElements={companyLog.totalElements}
                    totalPages={companyLog.totalPages}
                    currentPage={pageNumber}
                    pageSize={pageSize}
                    onPageChange={setPageNumber}
                    onPageSizeChange={setPageSize} // Permettiamo il cambio page size
                />
            ) : isError ? (
                <p>{JSON.stringify(error)}</p>
            ) : null
        }
    />
}

export default UserLog